"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";

import { useAuth } from "@/contexts/auth-context";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  const isLoginRoute = pathname === "/login";

  useEffect(() => {
    if (!isAuthenticated && !isLoginRoute) {
      router.replace("/login");
    }
  }, [isAuthenticated, isLoginRoute, router]);

  useEffect(() => {
    if (isAuthenticated && isLoginRoute) {
      router.replace("/new-home");
    }
  }, [isAuthenticated, isLoginRoute, router]);

  if (!isAuthenticated && !isLoginRoute) {
    return (
      <div className="flex min-h-svh items-center justify-center text-sm text-muted-foreground">
        Redirecting to login…
      </div>
    );
  }

  if (isAuthenticated && isLoginRoute) {
    return null;
  }

  return <>{children}</>;
}
